import request from '@/utils/request'

//已发布商品列表
export async function getAllGoods(data) {
  return await request({
    url: '/business-server/CommodityMgt/PublishedCommodityList',
    method: 'post',
    data
  })
}